import React from 'react';

const Inventory = {
    edition: function (inventory) {
        let edition;
        if (inventory.editions && inventory.editions.length > 0) {
            edition = inventory.editions[0];
        }
        return edition;
    },

    SubType: {
        options: (type) => {
            switch (type) {
                case Inventory.Type.Jewelry:
                    return [
                        { display: 'All' },
                        { value: '0', display: 'Ring' },
                        { value: '1', display: 'Necklace' },
                        { value: '2', display: 'Bracelet' },
                        { value: '3', display: 'Watch' },
                        { value: '4', display: 'Earrings' },
                        { value: '5', display: 'Cufflinks' },
                        { value: '6', display: 'Brooches' },
                        { value: '7', display: 'Other' }
                    ]
                case Inventory.Type.Furniture:
                    return [
                        { display: 'All' },
                        { value: '8', display: 'Chair' },
                        { value: '9', display: 'Sofa' },
                        { value: '10', display: 'Bench' },
                        { value: '11', display: 'Storage' },
                        { value: '12', display: 'Table' },
                        { value: '7', display: 'Other' }
                    ]
                case Inventory.Type.Lighting:
                    return [
                        { display: 'All' },
                        { value: '13', display: 'Wall Light and Sconce' },
                        { value: '14', display: 'Table Lamp' },
                        { value: '15', display: 'Floor Lamp' },
                        { value: '16', display: 'Chandelier/Pendant' },
                        { value: '7', display: 'Other' }
                    ]
                case Inventory.Type.Decor:
                    return [
                        { display: 'All' },
                        { value: '17', display: 'Rug and Carpet' },
                        { value: '18', display: 'Decorative Object' },
                        { value: '19', display: 'Mirror' },
                        { value: '20', display: 'Sculpture' },
                        { value: '21', display: 'Candle' },
                        { value: '22', display: 'Tableware' },
                        { value: '7', display: 'Other' }
                    ]
            }
        }
    },

    Type: {
        Artwork: '0',
        Merchandise: '1',
        Jewelry: '5',
        Furniture: '6',
        Lighting: '7',
        Decor: '8'
    }
};
export default Inventory;

function Subtitle(props) {
    let edition;
    const temp = Inventory.edition(props.data);
    if (temp && temp.edition && temp.edition.toString().length > 0) {
        edition = ` (${temp.edition})`
    }
    let date;
    if (props.data.date && props.data.date.toString().length > 0) {
        date = `, ${props.data.date}`;
    }
    return (
        <span className="artwork__info__item">
            <span className="artwork__info__item__edition">{edition}</span><span className="artwork__info__item__date">{date}</span>
        </span>
    );
}

export { Subtitle };